import {Base} from "@/api/Base"

export class OvertimeApplicationGet extends Base {
    path = "overtimeApplication/get"
}